import { AdminSubmitFeedback } from '@/app/pages/feedback/admin-submit-feedback';
import { createFileRoute } from '@tanstack/react-router';

import { adminFeedbackSearchSchema } from '@/features/review/config/admin-feedback-search-schema';

export const Route = createFileRoute('/admin-feedback/')({
  validateSearch: adminFeedbackSearchSchema,
  component: AdminSubmitFeedback,
});
